import { DateTime } from "luxon";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = DateTime.utc().year;

  return (
    <footer className="mt-auto border-t bg-brand-background">
      <div className="container py-6">
        <div className="flex flex-col items-center gap-4 text-sm text-muted-foreground md:flex-row md:justify-between">
          <div className="flex items-center gap-4">
            <Link 
              to="/terms" 
              className="transition-colors hover:text-foreground"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </Link>
            <span>·</span>
            <Link 
              to="/privacy" 
              className="transition-colors hover:text-foreground"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
            <span>·</span>
            <Link 
              to="/onlyfans-terms" 
              className="transition-colors hover:text-foreground"
              target="_self"
              rel="noopener noreferrer"
            >
              OnlyFans Terms
            </Link>
          </div>
          <div>
            © {currentYear} Upper Echelon LTD. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
